<template>
    <div class="out">
      <!-- 标题栏 -->
      <!-- <van-nav-bar :title="goodsChildName" left-arrow @click-left="onClickLeft" /> -->
      <img style="position: fixed;top: 50px;width: 200px;height: 200px;left: 45%;" src="/img/zxhl.png"/>
      <div class="page">
        <div class="zh">
          帐号：     <input type="text" v-model="accounts" class="text-black  margin-left-xl"   placeholder="请输入帐号"/>

        </div>
      </div>
      <div class="page">
        <div class="zh">
          密码： <input type="password" v-model="password" class="text-black margin-left-xl"   placeholder="请输入密码"/>
        </div>
      </div>
      <div @click="toPublish" class="dl" >登录</div>
    </div>
  </template>
  
  <script>
  import TimUiMedia from '@/components/TimUiMedia'
  import html2canvas from 'html2canvas'
  import QRCode from 'qrcode'
  export default {
    name: 'list',
    components: {
      TimUiMedia
    },
    data () {
      return {
        requestHeadUrl: 'https://xwt.kequbang.com',
        // requestHeadUrl: 'http://localhost:8280',
        // requestHeadUrl: 'http://192.168.1.25:8280',
        accounts: '',
        password: '',
      }
    },
    destroyed () {
        if(this.personFootInfo!=null){
          this.leavePersonFoot()
        }
    },
    mounted () {
      const thisObj = this
    //   thisObj.onLoad()
    },
    methods: {
      onLoad: function () {
        var rr = window.location.href.split('?')
        console.log(rr[rr.length-1])
        // alert(rr[rr.length-1])
        var ciphertext = rr[rr.length-1]
        const thisObj = this
        thisObj.$api.get(thisObj.requestHeadUrl + '/api/clip/get_clip_video?id='+ciphertext, {}).then(res => {
          // console.log(res)
            thisObj.list = res.data
            thisObj.nowInfo = res.data[0]
        }).catch(function (error) {
        })
      },
      toPublish() {
        const thisObj = this
        if (thisObj.accounts!='123456' || thisObj.password!='123456') {
            thisObj.$util.requetServerError('帐号或密码错误，请重新输入！')
            return
        }

        thisObj.$router.push({
          path: '/videoList',
        })


      },
      
    }
  }
  </script>
  <style scoped>
  .out {
    position: fixed;
    top: 40%;
    left: 34%;
    margin: 50px;
    padding: 50px;

  }
  .zh {
    margin: 30px;
    font-size: 30px;
  }
  .dl {
    padding: 15px;
    background: rgb(136, 136, 234);
    color: #ffffff;
    font-size: 30px;
    border-radius: 10px;
  }
  </style>
  